(function () {
  document.querySelectorAll('.community-section').forEach(initCommunitySection);

  function initCommunitySection(section) {
    const track = section.querySelector('[data-community-track]');
    const slides = Array.from(section.querySelectorAll('.community-slide'));
    const prevBtns = Array.from(section.querySelectorAll('.community-arrow--prev'));
    const nextBtns = Array.from(section.querySelectorAll('.community-arrow--next'));
    const currentEls = Array.from(section.querySelectorAll('[data-current]'));
    const totalEls = Array.from(section.querySelectorAll('[data-total]'));
    const indicatorFill = section.querySelector('[data-indicator-fill]');
    const autoplayEnabled = section.dataset.autoplay !== 'false';
    const isPeekMode = section.dataset.peek === 'true';

    totalEls.forEach((el) => (el.textContent = slides.length));

    // ----- Video play/pause (manual toggle always works; auto-play optional) -----
    slides.forEach((slide) => {
      const video = slide.querySelector('[data-video]');
      const toggle = slide.querySelector('[data-playpause]');
      if (!video || !toggle) return;

      const playIcon = toggle.querySelector('.icon-play');
      const pauseIcon = toggle.querySelector('.icon-pause');

      const setIcons = (playing) => {
        if (playIcon) playIcon.style.display = playing ? 'none' : 'block';
        if (pauseIcon) pauseIcon.style.display = playing ? 'flex' : 'none';
      };

      toggle.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          setIcons(true);
        } else {
          video.pause();
          setIcons(false);
        }
      });

      if (autoplayEnabled && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play().then(() => setIcons(true)).catch(() => {});
              } else {
                video.pause();
                setIcons(false);
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        observer.observe(video);
      }
    });

    // ----- Arrow navigation: target the exact next/prev slide by index -----
    // (fixes the desktop bug where a fixed pixel jump could overshoot past
    // the intended slide when center-snap / peek mode is active)
    function getCurrentIndex() {
      const trackRect = track.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let minDist = Infinity;
      slides.forEach((slide, i) => {
        const r = slide.getBoundingClientRect();
        const slideCenter = r.left + r.width / 2;
        const dist = Math.abs(slideCenter - centerX);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      const slide = slides[clamped];
      if (!slide) return;
      const useCenter = isPeekMode && window.matchMedia('(min-width: 750px)').matches;
      slide.scrollIntoView({
        behavior: 'smooth',
        inline: useCenter ? 'center' : 'start',
        block: 'nearest',
      });
    }

    prevBtns.forEach((btn) => btn.addEventListener('click', () => scrollToIndex(getCurrentIndex() - 1)));
    nextBtns.forEach((btn) => btn.addEventListener('click', () => scrollToIndex(getCurrentIndex() + 1)));

    // ----- Counter + mobile swipe indicator -----
    function updateProgress() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

      const approxIndex = Math.round(ratio * (slides.length - 1)) + 1;
      currentEls.forEach((el) => {
        el.textContent = Math.min(Math.max(approxIndex, 1), slides.length);
      });

      if (indicatorFill) {
        indicatorFill.style.width = (100 / slides.length) + '%';
        indicatorFill.style.transform = 'translateX(' + (ratio * (100 * (slides.length - 1))) + '%)';
      }

      prevBtns.forEach((btn) => (btn.disabled = track.scrollLeft <= 2));
      nextBtns.forEach((btn) => (btn.disabled = track.scrollLeft >= maxScroll - 2));
    }

    track.addEventListener('scroll', () => window.requestAnimationFrame(updateProgress), { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }
})();